import { useLoadedProduct } from '@/composables/useLoadedProduct';
import { computed } from 'vue';

function useProductHas3d() {
    const product = useLoadedProduct();

    const productHas3DModel = computed(() => product.value.has3d);

    return {
        productHas3DModel,
    };
}

export { useProductHas3d };
